/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
module.exports = {
    tag: 'defense',
    quality: 0.4,
    armorClass: 4,
    dodgeChance: 1.0
}